import { render, staticRenderFns } from "./SvgTwitter.vue?vue&type=template&id=22ed8eea"
import script from "./SvgTwitter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvgTwitter.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports